import React from 'react'
export const CartsAppContext = React.createContext({
  error: null,
  cart: {
    items: []
  },
  loading: true,
  checkoutPath: null,
  actions: {
    updateCartItem: () => {},
    saveCart: () => {},
    deleteCartItemTicket: () => {},
    deleteCartItem: () => {}
  }
})
